// extracted by mini-css-extract-plugin
module.exports = {"tablist":"TabsCards_tablist__jbiCe","tab":"TabsCards_tab__D_hIG","active":"TabsCards_active__bwe6B"};